import moment from 'moment/moment'

import { ConstructorArgs } from '../types/models'
import { BaseRecord } from './BaseRecord'
import { Team } from './Team'
import { User } from './User'

export type MemberConstructorArgs = ConstructorArgs<() => Member>

export class Member extends BaseRecord {
    readonly recordType = 'member'

    cancelledDate?: moment.Moment

    constructor(data?: Partial<MemberConstructorArgs>, params?: { team?: Team; person?: User }) {
        super(data)
        if (!data) {
            this.team = params?.team
            this.person = params?.person
            return
        }

        this.cancelledDate = this.propertyFromTimestampArg(data.cancelled_date)
    }

    clone(overrides?: Partial<MemberConstructorArgs>): Member {
        return new Member({ ...this.serializeForClone(), ...overrides })
    }

    static initWithTeamAndPerson(team: Team, person: User): Member {
        return new Member(undefined, { team, person })
    }

    deserialize(data: any) {
        super.deserialize(data)

        if (data.team) this.team = BaseRecord.fromSerializer(data.team, Team)
        if (data.person) this.person = BaseRecord.fromSerializer(data.person, User)
        if (data.cancelledDate) this.cancelledDate = moment(data.cancelledDate)
    }

    get team(): Team | undefined {
        return this.getForeignRecord('team', Team)
    }
    set team(team: Team | undefined) {
        this.setForeignRecord('team', team)
    }
    get person(): User | undefined {
        return this.getForeignRecord('person', User)
    }
    set person(person: User | undefined) {
        this.setForeignRecord('person', person)
    }
}
